import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Directive({
    selector: '[appBackgroundUrl]'
})
export class BackgroundUrlDirective {

    @Input('appBackgroundUrl')
    set url(url: string | undefined | SafeUrl) {
        if (url) {
            this.renderer.setStyle(this.element.nativeElement, 'backgroundImage', 'url(' + url + ')');
        } else {
            this.renderer.removeStyle(this.element.nativeElement, 'backgroundImage');
        }
    }

    constructor(private renderer: Renderer2, private element: ElementRef) {
    }

}
